<template>

    <div class="container">

        <div class="mb-2">
            <inertia-link :href="route('admin.attachments.index')">
                <i class="bi bi-arrow-left"></i>
                {{ __('Zur Übersicht') }}
            </inertia-link>
        </div>

        <div class="mb-4">
            <h1>{{ __('Datei bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="update">
                <form-fields :form="form" :attachment="attachment" :purpose-options="purposeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'attachment',
            'purposeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    _method: 'put',
                    title: this.attachment.title,
                    slug: this.attachment.slug,
                    source_url: this.attachment.source_url,
                    alt_text: this.attachment.alt_text,
                    purpose: this.attachment.purpose,
                    copyright: this.attachment.copyright,
                    description: this.attachment.description,
                    sort_order: this.attachment.sort_order,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
            update() {
                this.form.post(this.route('admin.attachments.update', this.attachment), {
                    // onSuccess: () => this.form.reset('password', 'avatar'),
                });
            }
        },
    }
</script>